import _ from 'lodash'
import { Link } from 'react-router-dom'
import { BlackjackIcon } from '../casino/icons'
import { CasinoGameCard } from '@/components/casino/lobby/game-card/CasinoGameCard'
import { CasinoGameCardList } from '@/components/casino/lobby/game-card/CasinoGameCardList'
import { HorizontalCarousel } from '@/components/casino/lobby/carousel/HorizontalCarousel'
import { CASINO_HOME_GAMES_COUNT } from '@/config/casino'
import { useGetCasinoGamesQuery } from '@/store/api/casinoApi'

export function CasinoGamesSection() {
	const { data, isLoading, isError } = useGetCasinoGamesQuery({
		is_recommended: true,
		page: 1,
		per_page: CASINO_HOME_GAMES_COUNT,
	})

	const games = data?.data ?? []
	const firstRowGames = _.slice(games, 0, 9)
	const secondRowGames = _.slice(games, 9, 18)

	return (
		<section className='flex flex-col gap-4'>
			<div className='flex items-center justify-between'>
				<div className='flex items-center gap-3'>
					<BlackjackIcon className='h-7 w-7 text-subtle-foreground' />
					<h2 className='text-2xl font-semibold tracking-[-0.12px] text-foreground'>Recommended Casino games</h2>
				</div>
				<Link
					to='/casino'
					className='rounded-xl border border-border bg-card px-6 py-3 text-sm font-semibold tracking-[-0.21px] text-foreground transition-colors hover:bg-accent'
				>
					All casino games
				</Link>
			</div>

			{isLoading || isError || _.isEmpty(games) ? (
				<CasinoGameCardList games={games} isLoading={isLoading} isError={isError} layout='carousel' skeletonCount={9} />
			) : (
				<div className='flex flex-col gap-4'>
					<HorizontalCarousel>
						{_.map(firstRowGames, (game) => (
							<CasinoGameCard key={game.id} game={game} />
						))}
					</HorizontalCarousel>
					{!_.isEmpty(secondRowGames) ? (
						<HorizontalCarousel>
							{_.map(secondRowGames, (game) => (
								<CasinoGameCard key={game.id} game={game} />
							))}
						</HorizontalCarousel>
					) : null}
				</div>
			)}
		</section>
	)
}
